export enum CallingRecordedMessages {
  WRITTEN_CONSENT = "WRITTEN_CONSENT",
  NEVER = "NEVER",
  NEEDS_REVIEW = "NEEDS_REVIEW",
}
